module.exports = __webpack_public_path__ + "img/02.7cff2c7c.jpg";